<template>
  <section>
    <div class="d-flex justify-space-between align-center">
      <Logo />
      <SearchMap class="d-sm-flex d-none justify-center align-center mt-2" />
      <Changelanguage />
    </div>
    <div class="d-sm-none d-flex justify-center align-center mt-2 m-auto flex-wrap">
      <SearchMap />
    </div>
  </section>
</template>
<script>
import Changelanguage from "./Changelanguage.vue";
import Logo from "./Logo.vue";
import SearchMap from "./SearchMap.vue";
export default {
  components: {
    Changelanguage,
    Logo,
    SearchMap,
  },
};
</script>
<style lang="scss" scoped>
$main-color: #0074c7;
$second-color: #fff;

.navbar-tabs {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.navbar-tab {
  color: $main-color;
  background: $second-color;
  border: 1px solid $main-color;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border 0.2s;
  &:hover {
    background: $main-color;
    color: $second-color;
    border-color: $main-color;
  }
  &.active {
    background: linear-gradient(90deg, $main-color 70%, $second-color 100%);
    color: $second-color;
    border-color: $main-color;
  }
}
</style>
